<ng-container *ngIf="frac">
  <sa-lmo-frac-home-card [localStorageKey]="localStorageKey">
    <header class="flex justify-between my-1 py-1">
      <div class="flex items-center">
        <img src="/assets/icons/location.svg" alt="Coordinates" class="w-4 h-4" />
        <span class="text-xl font-medium">Locations</span>
      </div>
    </header>
    <div class="flow-root ml-2 mr-2">
      <table class="w-full">
        <colgroup>
          <col class="w-1/3" />
          <col class="w-1/4" />
          <col class="w-1/4" />
          <col class="copy-icon" />
        </colgroup>
        <tbody>
          <!-- Well Coordinates -->
          <tr *ngIf="frac.site && frac.site.lngLat">
            <td class="py-1 text-lg font-bold align-middle">Well</td>
            <td class="py-1 align-middle">
              <p class="text-muted text-sm">Latitude</p>
              <p class="font-bold cursor-copy">{{ frac.site.lngLat[1] }}</p>
            </td>
            <td class="py-1 align-middle">
              <p class="text-muted text-sm">Longitude</p>
              <p class="font-bold cursor-copy">{{ frac.site.lngLat[0] }}</p>
            </td>
            <td class="py-1 align-middle">
              <button mat-icon-button (click)="copyCoordinates(frac.site.lngLat[1], frac.site.lngLat[0])">
                <mat-icon class="cursor-pointer text-gray-600">content_copy</mat-icon>
              </button>
            </td>
          </tr>

          <!-- Staging Coordinates -->
          <tr *ngIf="frac.site && frac.site.outerLngLat && frac.site.outerRadius">
            <td class="py-1 text-lg font-bold">Staging</td>
            <td class="py-1">
              <p class="text-muted text-sm">Latitude</p>
              <p class="font-bold cursor-copy">{{ frac.site.outerLngLat[1] }}</p>
            </td>
            <td class="py-1">
              <p class="text-muted text-sm">Longitude</p>
              <p class="font-bold cursor-copy">{{ frac.site.outerLngLat[0] }}</p>
            </td>
            <td>
              <button mat-icon-button (click)="copyCoordinates(frac.site.outerLngLat[1], frac.site.outerLngLat[0])">
                <mat-icon class="cursor-pointer text-gray-600">content_copy</mat-icon>
              </button>
            </td>
          </tr>

          <!-- GPS Coordinates -->
          <tr>
            <td class="py-1 text-lg font-bold">GPS Point</td>
            <td class="py-1">
              <p class="text-muted text-sm">Latitude</p>
              <p class="font-bold cursor-copy">{{ frac.gpsDirectionLocation[1] }}</p>
            </td>
            <td class="py-1">
              <p class="text-muted text-sm">Longitude</p>
              <p class="font-bold cursor-copy">{{ frac.gpsDirectionLocation[0] }}</p>
            </td>
            <td>
              <button
                mat-icon-button
                (click)="copyCoordinates(frac.gpsDirectionLocation[1], frac.gpsDirectionLocation[0])"
              >
                <mat-icon class="cursor-pointer text-gray-600">content_copy</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </sa-lmo-frac-home-card>
</ng-container>
